// 判断是否为android
export function isAndroidClient() {
    if (window.action != null && window.action != undefined) {
        return true;
    } else {
        return false;
    }
}
// 判断是否为ios
export function isIOSClient() {
    if (window.webkit != null && window.webkit != undefined && window.webkit.messageHandlers.pageBack) {
        return true;
    } else {
        return false;
    }
}
// 后退
export function goBack() {
    if (isAndroidClient()) {
        window.action.pageBack("");
    } else if (isIOSClient()) {
        window.webkit.messageHandlers.pageBack.postMessage("");
    }
}